export default "__VITE_ASSET__l03z7HAa__"